import {CustomActionField, type ICustomAction} from './schema';

export const customActionDefaults = {
	[CustomActionField.enabled]: true,
	[CustomActionField.name]: '',
	[CustomActionField.payloadUrl]: '',
	[CustomActionField.targetUrl]: '',
	[CustomActionField.userSelector]: {
		userSelectorId: -1,
		all: true,
		none: false,
		groups: [],
		users: [],
	},
};
